import { AdminTierTypeEnum } from '../services/drillDown';

export interface Pricebook {
  id: number;
  pricebookName: string;
  defaultPricebook: boolean;
  groupId: number;
  paidBy: string;
  productType: string;
  description: string[];
  logoUrl: string;
  artUrl: string;
  metadata: any;
  paymentType: string;
  addOn: boolean;
  skipPayment: boolean;
  allowCoupon: boolean;
  skipStripePayment: boolean;
  internalAdminDescription: string;
}

export interface Product {
  id: number;
  productName: string;
  productId: number;
  threeNickelsU: boolean;
  investmentAdvice: boolean;
}

export interface Processor {
  id: number;
  name: string;
}

export interface Price {
  id: number;
  productName: string;
  price: number;
  priceId: string;
  description: string;
  introductionPeriodInDays: number;
  subscriptionLengthInDays: number;
  intervalType: IntervalTypeEnum;
  product: Product;
  processor: Processor;
}

export interface PricebookBundle {
  pricebook: Pricebook;
  prices: Price[];
}

export interface PricebookBundleWithUsage extends PricebookBundle {
  inUse: boolean;
}

export interface AvailablePricebooks {
  pricebookBundleDtos: PricebookBundle[];
  tier: AdminTierTypeEnum;
}

export interface PricebookBundleMapping {
  id: number;
  primaryPricebookId: number;
  addOnPricebookId: number;
}

export enum PaymentTypeEnum {
  Metered = 'METERED_PAYMENT',
  Prepaid = 'PRE_PAID',
}

export enum ProductTypeEnum {
  Nickels = 'NICKELS',
  NickelsU = 'NICKELSU',
  GuidedChoice = 'GUIDED_CHOICE',
  Bundled = 'BUNDLED',
  Free = 'FREE',
  Total = 'TOTAL',
  Subscription = 'SUBSCRIPTION',
}

export const isProductType = (value: string | undefined): value is ProductTypeEnum =>
  value !== undefined && Object.values<string>(ProductTypeEnum).includes(value);

export enum IntervalTypeEnum {
  Month = 'MONTH',
  Year = 'YEAR',
  None = 'NONE',
}
